/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "2dadfb6c-ab96-11ec-b909-0242ac120002",
    youtubeId:"xC5uc5uATGc",
    title: "Badminton shots from 2021 - Top 10",
    description:
      "TOP 10 Badminton shots from 2021. Welcome to our top 10 shots from 2021; we hope you enjoy them. We have selected 10 of our favorite shots, deceptions, and trick shots from 2021. Returns, drives, defense, tricks, cut, backhand & more",
    videoThumbnail: "https://i.ytimg.com/vi/xC5uc5uATGc/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"trickshot",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "2dadfe82-ab96-11ec-b909-0242ac120002",
    youtubeId:"zrGh10iTwX0",
    title: "SPIN SERVE in badminton - 2 techniques",
    description:
      "SPIN SERVE in badminton - 2 techniques. The spin serve in badminton is a tricky shot to master, and you see more and more players do them. Kevin Sukamuljo was the first to introduce it without hitting the feathers. Sukamuljo puts so much spin into the serve, and I will try to show you how this is applied. I will show you 1 shot with a bit spin which is easier to apply and use, and then the big crazy spin serve as Kevin Sukamuljo does. Welcome to the badminton spin serve trick tutorial",
    videoThumbnail: "https://i.ytimg.com/vi/zrGh10iTwX0/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"trickshot",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae0332-ab96-11ec-b909-0242ac120002",
    youtubeId:"TiTm80LX4uU",
    title: "Badminton Tricks From Backcourt",
    description:
      "Badminton Tricks From Backcourt. Welcome to another trickshot video here on the channel. 3 trickshots from backcourt. They are funny, crazy and hard to do. They are mostly for fun, but 1 of them can actually be used in a real match, watch and see. We love tricks because when you have fun and try new stuff, you will learn new things and develop your skills with the racket.",
    videoThumbnail: "https://i.ytimg.com/vi/TiTm80LX4uU/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"trickshot",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae0490-ab96-11ec-b909-0242ac120002",
    youtubeId:"5DOgzV8l30s",
    title: "Badminton LIN DAN trickshot - Back facing shot",
    description:
      "Badminton LIN DAN trickshot - Back facing shot. This amazing tutorial back facing trickshot from Lin Dan is a MUST SEE, and a shot you must try yourself. Lin Dan is SO good at this fake backhand shot, I give my best but Lin Dan is just the master of this trick shot in badminton. To do a back facing shot takes skills, and only Lin Dan can pull it off with style.",
    videoThumbnail: "https://i.ytimg.com/vi/5DOgzV8l30s/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"trickshot",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae05da-ab96-11ec-b909-0242ac120002",
    youtubeId:"9r9lu_kBWYQ",
    title: "Badminton challenge - Low serve, how many can you get?",
    description:
      "Badminton challenge - Low serve, how many can you get? Badminton low serve is used a lot in badminton, so master the short serve and also focus on the precision. Attach a racket on the edge of the net and do low serves precision through the rackethead. The badminton serve is an important element in badminton.",
    videoThumbnail: "https://i.ytimg.com/vi/9r9lu_kBWYQ/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"trickshot",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae0742-ab96-11ec-b909-0242ac120002",
    youtubeId:"eNFBYQBwkg8",
    title: "Badminton TRICKSHOT - WOW Behind the head",
    description:
      "Badminton trickshot behind the head. This trickshot is SO crazy. A badminton trick you MUST try yourself, really funny trick, but also mostly for fun. Trickshots in badminton is mostly for fun, because the speed of the game is so fast. But fun to practise and still some body control practise in these shots for sure, so give it a try.🤩",
    videoThumbnail: "https://i.ytimg.com/vi/eNFBYQBwkg8/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"trickshot",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae0882-ab96-11ec-b909-0242ac120002",
    youtubeId:"ONnr77d4dQQ",
    title: "Badminton Doubles Defense - Cross short",
    description:
      "Badminton Doubles Defense - Cross short. Hope you are ready for a tricky shot, this is the doubles defense going short cross from the right field. So a Badminton defense block, where you aim for attacking the net, and changing things around. Use the basic double defense technique, but do not hit will full power, use a small finger power push and a forearm rotation from outside and into the shuttle. Watch and learn in this Badminton Doubles Defense cross short technique tutorial 😎",
    videoThumbnail: "https://i.ytimg.com/vi/ONnr77d4dQQ/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"defense",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae09a4-ab96-11ec-b909-0242ac120002",
    youtubeId:"1wuoT8AdFsM",
    title: "Badminton singles defense - Cross in Forehand and Backhand",
    description:
      "Badminton singles defense - Cross in Forehand and Backhand. Welcome to this how to tutorial about the cross defense in singles. I go through the defense footwork, the footwork where you are in control, not under full heavy pressure. Then I look at the techniques in the forehand and in the backhand. I talk about the grip, the wrist, the forearm, the angle and the finger power. Hope you enjoy this badminton singles defense tutorial 😎",
    videoThumbnail: "https://i.ytimg.com/vi/1wuoT8AdFsM/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"defense",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae0ac6-ab96-11ec-b909-0242ac120002",
    youtubeId:"sJcWuXcH7kQ",
    title: "Badminton Net Kill - Forehand 2 versions",
    description:
      "Badminton Net Kill - Forehand 2 versions and also the backhand version. The badminton net kill is very important to master to kill the shuttles at the net and score points. I cover the forehand version and also shows you the backhand version in this tutorial. The net kill forehand exercises can be where you throw to the net or multishuttle to the net. Go for the fast quick kill if you have time using fingerpower, or use the wiperblade move if you are close to the net.",
    videoThumbnail: "https://i.ytimg.com/vi/sJcWuXcH7kQ/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"defense",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae0eb8-ab96-11ec-b909-0242ac120002",
    youtubeId:"gIynLyyY0zU",
    title: "Badminton net kill - Doubles net player",
    description:
      "Badminton net kill - Doubles net player. Welcome to this net kill tutorial as the net player in the doubles. I will walk you through the footwork at the net, the technique of the net kill, and how to train this together with a feeder or a shuttle machine. It´s all about low gravity, racket ready, forehand grip, forearm rotation, and the quick kill using the kickback movement",
    videoThumbnail: "https://i.ytimg.com/vi/gIynLyyY0zU/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"defense",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae11ec-ab96-11ec-b909-0242ac120002",
    youtubeId:"CxVB0iIjvuU",
    title: "Badminton backhand slice cross court",
    description:
      "Badminton backhand slice cross court. This late backhand slice going cross is brutal to master but yet essential to learn. The technique in the shot is very similar to the straight slice; make sure you watch our tutorial on that shot. The backhand slice is a tricky shot with focus on grip, wrist, forearm rotation, elbow, and the follow-through",
    videoThumbnail: "https://i.ytimg.com/vi/CxVB0iIjvuU/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"defense",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae13a4-ab96-11ec-b909-0242ac120002",
    youtubeId:"2GMSxlRqdQ0",
    title: "Badminton Cross Shots | Must Learn deadzone shots",
    description:
      "Badminton Cross Shots | Must Learn deadzone shots. These cross shots in badminton is key to master to make awesome deadzone shots. The cross forehand and cross backhand shots from deadzone, is used many times in singles and in mixed doubles. This tutorial focuses on the version very close to the net, and also the version from deadzone to deadzone, forehand and backhand in both sides",
    videoThumbnail: "https://i.ytimg.com/vi/2GMSxlRqdQ0/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"defense",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae1520-ab96-11ec-b909-0242ac120002",
    youtubeId:"Un6YmO1gBK8",
    title: "Badminton double defense - short to the net",
    description:
      "Badminton double defense - short to the net tutorial. Are you ready to learn the badminton double defense where you slice the shuttle just a bit? The double defense technique in badminton is very important, and this short defense is a good variation to change things around in the game. Play it short to the net on the smash close to the net, that is a good badminton double defense.",
    videoThumbnail: "https://i.ytimg.com/vi/Un6YmO1gBK8/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"defense",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae1656-ab96-11ec-b909-0242ac120002",
    youtubeId:"SIVJqH90pU8",
    title: "How to use the feet in badminton - Footwork biomechanics",
    description:
      "How to use the feet in badminton - Footwork biomechanics.\nI will show you how to use correct footwork in badminton. I cover some of the basic moves in the badminton footwork. The footwork biomechanics is really important to get more balance, power, and low gravity, and to avoid injuries in your feet. With the correct badminton footwork, you will be able to cover the court much better and do better shots.",
    videoThumbnail: "https://i.ytimg.com/vi/SIVJqH90pU8/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"footwork",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae1778-ab96-11ec-b909-0242ac120002",
    youtubeId:"KwU3UwV3f6M",
    title: "IMPORTANT Badminton FOOTWORK - The LUNGE",
    description:
      " The lunge is used all the times in all areas of the badminton court. Master this movement and then you will be able to land better, do better strokes and move faster on court💪🏻.",
    videoThumbnail: "https://i.ytimg.com/vi/KwU3UwV3f6M/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"footwork",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae18b8-ab96-11ec-b909-0242ac120002",
    youtubeId:"I9ALMfFaiIE",
    title: "Basic FOOTWORK badminton - 4 corners",
    description:
      "In some cases you have to use a non-directltional split step, like in the defense to the sides. Also sometimes on the center if you are “waiting” for the opponents shot. The quickly change to a directional split step for the corner you want to go to👍🏻",
    videoThumbnail: "https://i.ytimg.com/vi/I9ALMfFaiIE/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"footwork",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae1bb0-ab96-11ec-b909-0242ac120002",
    youtubeId:"8xEzJQ09KyY",
    title: "Badminton China JUMP Footwork",
    description:
      "One of the most used badminton footwork jumps is the China Jump, or some call it the side shuffle jump. The China jump is good in these situation where you can jump out fast and reach the shuttle early and high to put pressure on your opponents.",
    videoThumbnail: "https://i.ytimg.com/vi/8xEzJQ09KyY/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"footwork",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae1d18-ab96-11ec-b909-0242ac120002",
    youtubeId:"1KT2jfzGnwM",
    title: "3 TIPS badminton FOOTWORK - Badminton Famly",
    description:
      "When you move on court it is important to move the best possible way, we got 3 hot tips for you to be better and faster on court.Remember to have patience when you train this, it is hard to master.",
    videoThumbnail: "https://i.ytimg.com/vi/1KT2jfzGnwM/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"footwork",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae20ce-ab96-11ec-b909-0242ac120002",
    youtubeId:"1KT2jfzGnwM",
    title: "How to use the upper body - 5 moves biomechanics",
    description:
      "How to use the upper body - 5 moves biomechanics. Welcome to this tutorial about how to use your upper body in badminton and how to move correctly for you to be faster, have better balance, make more variations, and hit with more power in your shots. The upper body is deeply connected to the footwork and the core. I show 5 wrong moves and then 5 correct ones.",
    videoThumbnail: "https://i.ytimg.com/vi/jiL3IrdOQf4/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"bio-mechanics",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae236c-ab96-11ec-b909-0242ac120002",
    youtubeId:"U1MmM6hj39c",
    title: "Badminton drop biomechanics - Easy tips",
    description:
      "Badminton drop biomechanics - Easy tips to learn in this tutorial about the badminton basic drop shot. I look at the biomechanics in the basic drop and will share some easy tips for you to train on your own. The badminton drop can be a great variation to all other overhead shots in badminton, so add the drop shot and get better attacking shots.",
    videoThumbnail: "https://i.ytimg.com/vi/U1MmM6hj39c/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"bio-mechanics",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae24ac-ab96-11ec-b909-0242ac120002",
    youtubeId:"CbmGhtK5A24",
    title: "Badminton clear bio-mechanics - 5 easy tips",
    description:
      "Badminton clear bio-mechanics - learn it here with 5 easy tips. The badminton clear technique is very simple but also very tricky to master at the same time. Let me share with you 5 easy tips to learn the badminton clear bio-mechanics. The use of the forearm rotation, the forehand grip and more are key factors in doing a perfect clear.",
    videoThumbnail: "https://i.ytimg.com/vi/CbmGhtK5A24/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"bio-mechanics",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae25f6-ab96-11ec-b909-0242ac120002",
    youtubeId:"wdm7qtjvZbk",
    title: "Badminton hammer grip - The panhandle grip tutorial",
    description:
      "Badminton hammer grip - The panhandle grip is used in many places on court, but still be careful using it too much, as you can get locked in that position. The hammer grip is the grip most beginners and kids use, as it is the most natural grip to do, because you think the strings need to be parallel towards the shuttle, but that is wrong. If you hold a 100% hammer/panhandle grip then you can´t rotate the forearm and add power to your shots. I will show you where to use it, and how to use it - Let´s GO😃",
    videoThumbnail: "https://i.ytimg.com/vi/wdm7qtjvZbk/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"bio-mechanics",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae289e-ab96-11ec-b909-0242ac120002",
    youtubeId:"3vatPgXL8NI",
    title: "MUST learn Forearm Rotation Bio-Mechanics",
    description:
      "This video is a MUST WATCH video about how train the forearm rotation. How, why and where? We cover all aspects in this tutorial. If you want more badminton power in your smash, drives, lifts etc. then you must learn this movement - Without a forearm rotation you can't have powerful drives!",
    videoThumbnail: "https://i.ytimg.com/vi/3vatPgXL8NI/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"bio-mechanics",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj" 
  },
  {
    _id: "2dae29f2-ab96-11ec-b909-0242ac120002",
    youtubeId:"WmDl_048fDk",
    title: "How Should We Use the Wrist?",
    description:
      "A lot of you guys in the Badminton Famly have requested clarification of the wrist movement, so here it is.Here comes the nerdy stuff.People are asking how we get power, how can we get more powerful smashes. Actually, we don't want to aim for power when we practice. We want to aim for efficiency and efficient movement and then power will come automatically.",
    videoThumbnail: "https://i.ytimg.com/vi/WmDl_048fDk/mqdefault.jpg",
    channelTitle:"Badminton Famly",
    category:"bio-mechanics",
    channelThumbnail:"https://yt3.ggpht.com/ytc/AKedOLQ8uUyZP-fdAtjaiqpp6mcdJWIxyAOlFU7BCwZHIw=s88-c-k-c0x00ffffff-no-rj"
  }
];
